// extracted by mini-css-extract-plugin
export var container = "EmpaneledDoctors-module--container--dK2-v";
export var empaneledDoctorsSection = "EmpaneledDoctors-module--empaneledDoctorsSection--jk-At";
export var header = "EmpaneledDoctors-module--header--ZYR3I";
export var loadMoreButton = "EmpaneledDoctors-module--loadMoreButton--G5bmB";
export var loadMoreWrapper = "EmpaneledDoctors-module--loadMoreWrapper--Ap43w";
export var title = "EmpaneledDoctors-module--title--JVDmL";